import React from "react";
import { Check, EyeOff, ShieldCheck, SlidersVertical } from "lucide-react";
import { icon } from "../ui";

const WILL_SEE = [
  "Your scores in each game",
  "Which level you have reached",
  "When you play, and for how long",
];
const WONT_SEE = [
  "Your password or payment details",
  "Anything you share with other providers",
  "Anything outside MendGrove games",
];

// Who is asking and exactly what sharing means. Shown wherever a player
// agrees to share: My care team and the /join page.
const ConsentDetails = ({ provider }) => (
  <>
    <div className="ct-consent-provider">
      <span className="ct-provider-card__name">{provider.name}</span>
      {provider.profession_label && <span>{provider.profession_label}</span>}
      {provider.organization && <span>{provider.organization}</span>}
      {provider.verified && (
        <span className="ct-verified">
          {icon(ShieldCheck)}
          Verified MendGrove provider
        </span>
      )}
    </div>
    <section className="ct-section" style={{ gap: 10 }}>
      <h2>They will see</h2>
      <ul className="ct-consent-list ct-consent-list--see">
        {WILL_SEE.map((text) => (
          <li key={text}>
            {icon(Check, 22)}
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </section>
    <section className="ct-section" style={{ gap: 10 }}>
      <h2>They can</h2>
      <ul className="ct-consent-list ct-consent-list--can">
        <li>
          {icon(SlidersVertical, 22)}
          <span>Change game settings for you, like the starting level</span>
        </li>
      </ul>
    </section>
    <section className="ct-section" style={{ gap: 10 }}>
      <h2>They won't see</h2>
      <ul className="ct-consent-list ct-consent-list--wont">
        {WONT_SEE.map((text) => (
          <li key={text}>
            {icon(EyeOff, 22)}
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </section>
    <div className="ct-control-box">
      <strong>You're in control</strong>
      <span>You can stop sharing at any time in Settings → My care team.</span>
    </div>
  </>
);

export default ConsentDetails;
